import Route from 'mewe/routes/route';

export default class Ambassadors extends Route {}
